/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Not_FoundInputs */

const en_jobs_not_found = /** @type {(inputs: Jobs_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job not found`)
};

const de_jobs_not_found = /** @type {(inputs: Jobs_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stelle nicht gefunden`)
};

const fr_jobs_not_found = /** @type {(inputs: Jobs_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emploi introuvable`)
};

const es_jobs_not_found = /** @type {(inputs: Jobs_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empleo no encontrado`)
};

const it_jobs_not_found = /** @type {(inputs: Jobs_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lavoro non trovato`)
};

const nl_jobs_not_found = /** @type {(inputs: Jobs_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baan niet gevonden`)
};

const pl_jobs_not_found = /** @type {(inputs: Jobs_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferta nie znaleziona`)
};

const fi_jobs_not_found = /** @type {(inputs: Jobs_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Työpaikkaa ei löytynyt`)
};

const da_jobs_not_found = /** @type {(inputs: Jobs_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job ikke fundet`)
};

const sv_jobs_not_found = /** @type {(inputs: Jobs_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobb hittades inte`)
};

/**
* | output |
* | --- |
* | "Job not found" |
*
* @param {Jobs_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_not_found = /** @type {((inputs?: Jobs_Not_FoundInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Not_FoundInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_not_found(inputs)
	if (locale === "fr") return fr_jobs_not_found(inputs)
	if (locale === "es") return es_jobs_not_found(inputs)
	if (locale === "it") return it_jobs_not_found(inputs)
	if (locale === "nl") return nl_jobs_not_found(inputs)
	if (locale === "pl") return pl_jobs_not_found(inputs)
	if (locale === "fi") return fi_jobs_not_found(inputs)
	if (locale === "da") return da_jobs_not_found(inputs)
	if (locale === "sv") return sv_jobs_not_found(inputs)
	return en_jobs_not_found(inputs)
});